import { Component, OnInit } from '@angular/core';
import { ContentService } from '../services/content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonGalleryDialogComponent } from '../common-gallery-dialog/common-gallery-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-case-studies-list',
  templateUrl: './case-studies-list.component.html',
  styleUrls: ['./case-studies-list.component.scss']
})
export class CaseStudiesListComponent implements OnInit {
  activeContainer = 1;
  case:any
  activeCase = ''
  id = ''

  constructor(
    private contentService : ContentService,
    private route:Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.fetchData()
  }

  fetchData(){
    const splittedUrl = this.route.url.split("/")
    this.id = splittedUrl[splittedUrl.length-1];
    this.activeCase = splittedUrl[splittedUrl.length -2 ]
    // console.log(this.activeCase)
    this.getActiveCaseContent(this.id)
    this.fetchOtherCaseStudies()
  }

  studyCard:any = []

  disableScroll(event: any) {
    event.preventDefault();
  }

  getActiveCaseContent(id:any){
    let params = `id=${id}`;
    this.contentService.getPublicContent('list', params).subscribe((res:any)=>{
      this.case = res?.wrapperList[0];
    })
  }


  nextSlide() {
    const container = document.querySelector('.slider-main') as HTMLElement;
    container.classList.add('fade-out');
    container.scroll({
      left: container.scrollLeft + 345,
      behavior: 'smooth',
    });
    setTimeout(() => {
      container.classList.remove('fade-out'); // Remove fade class after 3 seconds
    }, 400);
  }
  previousSlide() {
    const container = document.querySelector('.slider-main') as HTMLElement;
    container.scroll({
      left: container.scrollLeft - 345,
      behavior: 'smooth',
    });
  }

  navigateToCaseStudy(item:any){
    this.route.navigate(["case-studies-list",this.activeCase,item.id]).then(()=>{
      this.fetchData()
    })
  }

  goBack(){
    this.route.navigate(['/resources', this.activeCase ])
  }

  fetchOtherCaseStudies(){
    let params = this.activeCase == 'circular-information'? `moduleId=31&page=1&subModuleId=32` :this.activeCase == 'case-study' ?  `moduleId=29&page=1&subModuleId=40` : `moduleId=28&page=1&subModuleId=29`;
    this.contentService.getPublicContent('list', params).subscribe((res:any)=>{
       this.studyCard =  res.wrapperList.filter((list:any)=>list.id != this.id)

       // console.log('Study Card: ',this.studyCard);
       
    })
  }

  openDialog(fileList: any) {
    const dialogRef = this.dialog.open(CommonGalleryDialogComponent, {
      data: {
        fileList: fileList,
      },
      width: '800px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      // console.log(`Dialog result: ${result}`);
    });
  }

}
